import { render, staticRenderFns } from "./BibleResults.vue?vue&type=template&id=6778bfe3&scoped=true&lang=html"
import script from "./BibleResults.vue?vue&type=script&lang=js"
export * from "./BibleResults.vue?vue&type=script&lang=js"
import style0 from "./BibleResults.vue?vue&type=style&index=0&id=6778bfe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778bfe3",
  null
  
)

export default component.exports